import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input" ]

  connect() {
  }

  remove(event, callback = null) {
    event.preventDefault();
    const willRemove = event.currentTarget.dataset["removable"] === "true"
    
    if (willRemove) {
      this.element.remove();
    } else {
      this.inputTarget.value = 1
      this.element.classList.add("d-none");
    }
    
    // Notificar al controlador de exclusión de productos que se eliminó un campo
    const formContainer = this.element.closest('[data-controller*="menu-product-exclusion"]')
    if (formContainer) {
      const exclusionController = this.application.getControllerForElementAndIdentifier(
        formContainer,
        'menu-product-exclusion'
      )
      if (exclusionController) {
        exclusionController.fieldRemoved()
      }
    }
  }
}
